export default __webpack_public_path__ + "static/img_main_sp-056bd142e4799bfea40c5a995260e302.png";